import React from 'react';
import { getSearchResult } from '../actions/searchAction';
import { Component } from 'react';
import { bindActionCreators } from 'redux';
import Header from '../components/HeaderComponent';
import { connect } from 'react-redux';
import "../styles/ProcurementPortalStyles.css";
import { Redirect } from 'react-router-dom';
import { fetchFollowupTasks } from '../actions/followupActions';
import { followupTaskColumns } from "../config/column_fields";
import Select from 'react-select';
import axios from 'axios';
import ReactTable from "react-table";
import url from '../config';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Modal from 'react-responsive-modal';

class FollowUpTasks extends Component {

    constructor() {
        super();
        this.state = {
            userObj: {},
            received: false,
            filterData: {},
            tasks: [],
            comments: [],
            markDoneComment: '',
            updatedDueDate: '',
            dueDateChangeComment: '',
            markDoneTaskId: '',
            updateDateTaskId: ''
        };
    }

    componentWillMount() {
        this.props.fetchFollowupTasks({ status: ['Open'] });
        if (localStorage.getItem("userObj")) {
            let userObj = JSON.parse(localStorage.getItem("userObj"));
            this.setState({
                userObj
            })
        }
    }

    componentWillReceiveProps({ taskDataReceived, tasks }) {
        this.setState({ received: taskDataReceived, tasks: tasks })
    }

    multiSelectType = (name, options) => {
        return (
            <div className="form-group" style={{ width: '100%' }}>
                <Select
                    isMulti
                    isSearchable
                    onChange={(e) => { this.handleMultiSelectChange(e, name) }}
                    name={name}
                    options={options}
                />
            </div>
        )
    }

    handleMultiSelectChange = (e, name) => {
        console.log(e, name);
        this.setState({
            filterData: {
                ...this.state.filterData,
                [name]: (e || []).map(row => row.value)
            }
        })
    }

    onApplyFilter = () => {
        console.log(this.state.filterData);
        this.setState({ received: false })
        this.props.fetchFollowupTasks(this.state.filterData);
    }

    inputType = (name, value, type, placeholder) => {
        return <input type={type} placeholder={placeholder} className="form-control" name={name} value={value} onChange={(e) => this.handleInputChange(e)} />
    }

    handleInputChange = (e) => {
        let { name, value } = e.target;
        this.setState({
            filterData: {
                ...this.state.filterData,
                [name]: value
            }
        })
    }

    // markDone = async (id) => {
    //     try {
    //         console.log(id)
    //         let response = await axios.post(url.pathBackend + "sales/followup/markTaskDone", {
    //             taskId: id
    //         });
    //         let tasks = JSON.parse(JSON.stringify(this.state.tasks));
    //         let tasksData = tasks.map(row => {
    //             if (row.id == id) {
    //                 row.status = "Done";
    //             }
    //             return row;
    //         })
    //         this.setState({ tasks: tasksData })
    //     }
    //     catch (error) {
    //         console.log("Error in markDone", error);
    //     }
    // }

    fetchComments = async (leadId) => {
        try {
            console.log("fetchComments", leadId);
            this.setState({ comments: [], commentsModal: true, commentsLoading: true })
            let response = await axios.post(url.pathBackend + "lead/comments/" + leadId);
            console.log(response.data);
            this.setState({
                comments: (response.data || []).sort((a, b) => +b.timestamp - +a.timestamp),
                commentsLoading: false
            })
        }
        catch (error) {
            console.log("Error in fetch comments");
        }
    }

    closeCommentsModal = () => {
        this.setState({ comments: [], commentsModal: false })
    }

    handleUpdateFormChange = (e) => {
        let { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }

    openMarkDoneModal = (id) => {
        this.setState({
            markDoneTaskId: id,
            markDoneModal: true
        })
    }

    closeMarkDoneModal = () => {
        this.setState({
            markDoneTaskId: '',
            markDoneModal: false
        })
    }

    handleMarkDoneSubmit = async () => {
        let { markDoneTaskId, markDoneComment } = this.state;
        if(!markDoneComment) {
            alert("Please enter comment");
            return;
        }
        if(!markDoneTaskId) {
            alert("Some error occured");
            return;
        }
        try {
            console.log(markDoneTaskId)
            let tasks = JSON.parse(JSON.stringify(this.state.tasks));
            let bitrixId = '';
            let tasksData = tasks.map(row => {
                if (row.id == markDoneTaskId) {
                    row.status = "Done";
                    bitrixId = row.bitrixId;
                }
                return row;
            })
            let response = await axios.post(url.pathBackend + "sales/followup/markTaskDone", {
                taskId: markDoneTaskId,
                comment: markDoneComment,
                bitrixId: bitrixId
            });
            this.setState({ tasks: tasksData })
            this.closeMarkDoneModal();
        }
        catch (error) {
            console.log("Error in markDone", error);
        }
    }

    openDueDateModal = (id, dueDate) => {
        console.log(id, dueDate);
        this.setState({
            updateDateTaskId: id,
            dueDateModal: true,
            updatedDueDate: moment(dueDate, "YYYYMMDD").format("YYYY-MM-DD")
        })
    }

    closeDueDateModal = () => {
        this.setState({
            updateDateTaskId: '',
            dueDateModal: false,
            updatedDueDate: ''
        })
    }

    handleDueDateSubmit = async () => {
        let { dueDateChangeComment, updateDateTaskId, updatedDueDate } = this.state;
        console.log(dueDateChangeComment, updateDateTaskId, updatedDueDate)
        if(!dueDateChangeComment) {
            alert("Please enter comment");
            return;
        }
        if(!updateDateTaskId) {
            alert("Some error occured");
            return;
        }
        try {
            console.log(updateDateTaskId)
            updatedDueDate = moment(updatedDueDate).format("YYYYMMDD");
            let tasks = JSON.parse(JSON.stringify(this.state.tasks));
            let bitrixId = '';
            let tasksData = tasks.map(row => {
                if (row.id == updateDateTaskId) {
                    row.dueDate = updatedDueDate;
                    bitrixId = row.bitrixId;
                }
                return row;
            })
            let response = await axios.post(url.pathBackend + "sales/followup/changeDueDate", {
                taskId: updateDateTaskId,
                comment: dueDateChangeComment,
                updatedDueDate: updatedDueDate,
                bitrixId: bitrixId
            });
            this.setState({ tasks: tasksData })
            this.closeDueDateModal();
        }
        catch (error) {
            console.log("Error in handleDueDateSubmit", error);
        }
    }

    render() {

        let { state, props } = this;

        const taskOptions = ['Open', 'Done', 'Closed'];

        const taskColumns = [
            {
                Header: "Task Id",
                accessor: "id"
            },
            {
                Header: "Customer Name",
                accessor: "TITLE"
            },
            {
                Header: "Quote Id",
                accessor: "QUOTE_ID",
                Cell: row => (
                    <div>
                        <Link to={"/lead/followup/" + row.original.bitrixId} onClick={(event) => { event.preventDefault(); window.open(window.location.origin + "/lead/followup/" + row.original.bitrixId); }}>{row.value}</Link>
                    </div>
                )
            },
            {
                Header: "Region",
                accessor: "REGION"
            },
            {
                Header: "Next action date",
                accessor: "NEXT_ACTION_DATE",
                Cell: row => {
                    return <div>{row.value && moment(row.value, "YYYYMMDD").isValid() ? moment(row.value, "YYYYMMDD").format("DD MMM YYYY") : ""}</div>
                }
            },
            {
                Header: "Prospect",
                accessor: "PROSPECT"
            },
            {
                Header: "Sales person",
                accessor: "quoteIdTakenBy"
            },
            {
                Header: "System Size",
                accessor: "systemSize"
            },
            {
                Header: "Price",
                accessor: "price"
            },
            {
                Header: "Due Date",
                accessor: "dueDate",
                Cell: row => {
                    return <div>{row.value && moment(row.value, "YYYYMMDD").isValid() ? <button onClick={() => this.openDueDateModal(row.original.id, row.value)} className='btn btn-sm btn-success'>{moment(row.value, "YYYYMMDD").format("DD MMM YYYY")}</button> : ""}</div>
                }
            },
            {
                Header: "Status",
                accessor: "status"
            },
            {
                Header: "Anchor Type",
                accessor: "anchorType"
            },
            {
                Header: 'Comments',
                accessor: 'comments',
                Cell: row => {
                    return <button onClick={() => this.fetchComments(row.original.bitrixId)} className='btn btn-sm btn-info'>Comments</button>
                }
            },
            {
                Header: 'Mark Done',
                accessor: 'status',
                Cell: row => {
                    return row.value == "Open" ? <button onClick={() => this.openMarkDoneModal(row.original.id)} className='btn btn-sm btn-success'>Done</button> : ""
                }
            }
        ];

        const modalStyles = {
            modal: {
                width: '60%',
                maxWidth: '60%',
                padding: '40px',
                background: '#f7f7f7'
            }
        }

        return (
            <div>
                <Header />
                <div className={`container-fluid procurementMainDiv`}>
                    <div className="row leadtransferTopbarSection">
                        <div className="col-md-3">
                            <label>Task Start Date</label>
                            {this.inputType("startDate", this.state.filterData.startDate, "date")}
                        </div>
                        <div className="col-md-3">
                            <label>Task End Date</label>
                            {this.inputType("endDate", this.state.filterData.endDate, "date")}
                        </div>
                        <div className="col-md-3">
                            <label>Status</label>
                            {this.multiSelectType("status", taskOptions.map(status => ({ label: status, value: status })))}
                        </div>
                        <div className="col-md-3">
                            <button className="btn btn-success leadTransferSubmitButton" onClick={(e) => { this.onApplyFilter() }}>Submit</button>
                        </div>
                    </div>
                    <ReactTable
                        filterable={true}
                        showPagination={true}
                        sortable={true}
                        data={this.state.tasks}
                        columns={[...taskColumns]}
                        defaultSorted={[{ id: "id", desc: true }]}
                        defaultFilterMethod={(filter, row) =>
                            String(row[filter.id])
                                .toLowerCase()
                                .indexOf(filter.value.toLowerCase()) > -1
                        }
                        defaultPageSize={20}
                        loading={!this.state.received}
                    />
                    <Modal open={this.state.commentsModal} onClose={this.closeCommentsModal} styles={modalStyles} center>
                        <h5 style={{ textAlign: 'center' }}>Comments ({(this.state.comments || []).length})</h5>
                        <div className="border p-2 overflow-auto modal-body" style={{ maxHeight: "300px" }}>
                            {(this.state.comments || []).map((comment) => {
                                return <div><p><b>{comment.commentedBy} {moment(+(comment.timestamp)).format('DD/MM/YYYY hh:mm a')} </b> {comment.commentBody.replace(/&nbsp;/g, '  ')}</p></div>
                            })}
                        </div>
                    </Modal>
                    <Modal open={this.state.markDoneModal} onClose={this.closeMarkDoneModal} styles={modalStyles} center>
                        <h5 style={{ textAlign: 'center' }}>Mark Done</h5>
                        <div class="form-group">
                            <label>Comment</label>
                            <input type="textarea" className="form-control" value={this.state.markDoneComment} name='markDoneComment' onChange={this.handleUpdateFormChange} />
                        </div>
                        <div class="form-group mt-3" style={{ textAlign: 'center' }}>
                            <button className='btn btn-outline-primary' onClick={this.handleMarkDoneSubmit}>Submit</button>
                        </div>
                    </Modal>
                    <Modal open={this.state.dueDateModal} onClose={this.closeDueDateModal} styles={modalStyles} center>
                        <h5 style={{ textAlign: 'center' }}>Change due date</h5>
                        <div class="form-group">
                            <label>Due Date</label>
                            <input type="date" className="form-control" value={this.state.updatedDueDate} name='updatedDueDate' onChange={this.handleUpdateFormChange} />
                        </div>
                        <div class="form-group">
                            <label>Comment</label>
                            <input type="textarea" className="form-control" value={this.state.dueDateChangeComment} name='dueDateChangeComment' onChange={this.handleUpdateFormChange} />
                        </div>
                        <div class="form-group mt-3" style={{ textAlign: 'center' }}>
                            <button className='btn btn-outline-primary' onClick={this.handleDueDateSubmit}>Submit</button>
                        </div>
                    </Modal>
                </div>
            </div>
        )
    }

}

function mapStateToProps({ followup }) {
    let { tasks = [], taskDataReceived = false } = followup;
    return {
        tasks,
        taskDataReceived
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ getSearchResult, fetchFollowupTasks }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FollowUpTasks);